import { render } from "./Password.vue?vue&type=template&id=c4c67320"
import script from "./Password.vue?vue&type=script&setup=true&lang=js"
export * from "./Password.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/Password.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4c67320"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4c67320', __exports__)) {
    api.reload('c4c67320', __exports__)
  }
  
  module.hot.accept("./Password.vue?vue&type=template&id=c4c67320", () => {
    api.rerender('c4c67320', render)
  })

}


export default __exports__